// components/blog/CoverImageInput.js
import React, { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import api from '../../utils/api';

const CoverImageInput = () => {
  const { register, setValue } = useFormContext();
  const coverImage = useWatch({ name: 'cover_image' });

  const [preview, setPreview] = useState('');
  const [loading, setLoading] = useState(false);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    setLoading(true);
    try {
      const res = await api.post('/api/uploads', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const imagePath = res.data.url;
      const fullUrl = `${process.env.REACT_APP_API_URL}${imagePath}`;

      setValue('cover_image', imagePath); // guarda solo la ruta relativa
      setPreview(fullUrl); // muestra preview con dominio
    } catch (err) {
      console.error('Error al subir imagen:', err);
      alert('No se pudo subir la imagen');
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = () => {
    setValue('cover_image', '');
    setPreview('');
  };

  const imageUrl = preview || (coverImage ? `${process.env.REACT_APP_API_URL}${coverImage}` : '');

  return (
    <div className="bg-white p-4 rounded-lg shadow-sm">
      <h2 className="text-sm font-semibold mb-2">Imagen destacada</h2>

      {imageUrl && (
        <div className="mb-2 relative">
          <img
            src={imageUrl}
            alt="Previsualización"
            className="rounded w-full h-auto object-cover"
          />
          <button
            type="button"
            onClick={handleRemove}
            className="absolute top-2 right-2 px-2 py-1 text-xs bg-red-500 text-white rounded hover:bg-red-600"
          >
            Quitar
          </button>
        </div>
      )}

      <input
        type="file"
        accept="image/*"
        onChange={handleUpload}
        disabled={loading}
        className="w-full px-3 py-2 border rounded-md text-sm bg-gray-50"
      />

      {/* Campo oculto que guarda la URL relativa */}
      <input type="hidden" {...register('cover_image')} />
    </div>
  );
};

export default CoverImageInput;
